import { Grid } from '@mui/material';
import React, { useState } from 'react';
import CustomTextField from '../formFields/textField';
import { t } from 'i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { BankDetailsSchema } from 'src/config/yup';
import { useForm } from 'react-hook-form';
import { ADD_BANK, UPDATE_BANK } from 'src/apiService/apiDeclaration';
import { showErrorTost, showSuccessTost } from 'src/constants';
import LoaderButton from '../loaderButton/loaderButton';

const BankDetails = ({ data, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(BankDetailsSchema),
    defaultValues: { ...data },
  });

  const onSubmit = async (body) => {
    setLoading(true);
    try {
      let resp;
      data ? (resp = await UPDATE_BANK(data._id, body)) : (resp = await ADD_BANK(body));
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setLoading(false);
      onSuccess();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <CustomTextField
            label={t('bankDetails.bankName')}
            controller={{
              name: 'bankName',
              control: control,
              errors: errors.bankName,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            label={t('bankDetails.AccName')}
            controller={{
              name: 'accountName',
              control: control,
              errors: errors.accountName,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            label={t('bankDetails.AccNo')}
            controller={{
              name: 'accountNumber',
              control: control,
              errors: errors.accountNumber,
            }}
          />
        </Grid>
        <Grid item xs={4} sx={{ ml: 'auto' }}>
          <LoaderButton
            disabled={!isDirty}
            buttonText={data ? t('common.edit') : t('common.add')}
            loading={loading}
            type={'submit'}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default BankDetails;
